module.exports = "/fonts/Arial.eot?9a58d8389133261e03eef69c9d96224e";